/** 数据中心 → 泡茶机数据 → 单杯参数（patch 157；品质分析，不影响原单杯数据） */
export const TEA_SINGLE_CUP_PARAMS_MENU_IDS = {
  page: 990413,
  enName: 'teaSingleCupParams',
  parentEnName: 'dataOfTeaExtractorMachine'
}



// WEBPACK FOOTER //
// ./src/constants/teaSingleCupParams.js